module.exports = __webpack_public_path__ + "static/img/xxtb2.90215a77.png";